import { defineStore } from 'pinia';
import { FundraisingProjectStep1 } from '@/models/fundraising-project-step1.model';
import { FundraisingProjectStep3 } from '@/models/fundraising-project-step3.model';

export interface FundraisingStoreState {
  step1: FundraisingProjectStep1;
  step3: FundraisingProjectStep3;
  projectId?: string;
  selectedSchoolReserved?: boolean
  avatarSource?: 'default' | 'uploaded' | '';
  roundedTargetSliderMin?: number;
  roundedTargetSliderMax?: number;
}

export const useFundraisingStore = defineStore('fundraising', {
  state: (): FundraisingStoreState => {
    return {
      step1: {
        amount: 500,
        projectName: '',
        projectAbout: '',
        projectImage:
          'https://res.cloudinary.com/djyeswqkn/image/upload/v1727442516/gel7nyxp7rrvlrdcwvjc.jpg',
        projectAvatarImage: undefined,
        projectStartDate: '',
        projectEndDate: '',
        userAbout: '',
        userImage: '',
        projectType: 'general',
        fundraiserType: '',
        fundraiserGroupName: '',
        schoolDetails: {
          sfAccountId: '',
          schoolCountry: '',
          schoolName: '',
          enrolmentNumber: 0
        },
      },
      step3: {
        confirmPreview: false,
        project_template_id: 'Fundraising Project Template1',
        category: 'General',
      },
      projectId: undefined,
      selectedSchoolReserved: false,
      avatarSource: '',
      roundedTargetSliderMin: 0,
      roundedTargetSliderMax: 0,
    } as FundraisingStoreState;
  },
  getters: {
    getAmount: (state) => state.step1.amount,
    getStep1: (state) => state.step1,
    getStep3: (state) => state.step3,
    getProjectImage: (state) => state.step1.projectImage,
    getProjectAvatarImage: (state) => state.step1.projectAvatarImage,
    getSelectedSchoolName: (state) => state.step1.schoolDetails.schoolName,
    getSelectedSchoolId: (state) => state.step1.schoolDetails.sfAccountId,
    getSchoolReserved: (state) => state.selectedSchoolReserved,
    getProjectType: (state) => state.step1.projectType,
    getRoundedTargetSliderMin: (state) => state.roundedTargetSliderMin,
    getRoundedTargetSliderMax: (state) => state.roundedTargetSliderMax,
  },
  actions: {
    setConfirmedPreview() {
      this.step3.confirmPreview = true;
    },
    setSchoolReserved(reserved: boolean) {
      this.selectedSchoolReserved = reserved;
    },
    setRoundedTargetSliderMinMax(min: number, max: number) {
      this.roundedTargetSliderMin = min;
      this.roundedTargetSliderMax = max;
    },
    resetFundraisingStore() {
      this.step1.amount = 500;
      this.step1.projectAbout = '';
      this.step1.projectName = '';
      this.step1.projectImage = 'https://res.cloudinary.com/djyeswqkn/image/upload/v1727442516/gel7nyxp7rrvlrdcwvjc.jpg';
      this.step1.projectAvatarImage = undefined;
      this.step1.projectStartDate = '';
      this.step1.projectEndDate = '';
      this.step1.userAbout = '';
      this.step1.projectType = 'general';
      this.step1.fundraiserType = '';
      this.step1.fundraiserGroupName = '';
      this.step1.schoolDetails.sfAccountId = '';
      this.step1.schoolDetails.schoolCountry = '';
      this.step1.schoolDetails.schoolName = '';
      this.step1.schoolDetails.enrolmentNumber= 0;
      this.step3.confirmPreview = false;
      this.step3.project_template_id = 'Fundraising Project Template1';
      this.roundedTargetSliderMin = 0;
      this.roundedTargetSliderMax = 0;
    }
  },
});
